import React, { useEffect, useMemo, useRef } from "react";
import { PeekBox, PeekGrid, PeekStack, useTheme } from "@piiqtechnologies/ui-components";
import TopSourcesHeader from "./TopSourcesHeader";
import TopSourcesRow from "./TopSourcesRow";
export const TopSourcesBody = ({ sources, highlightedSourceName, scrollToSourceName, onRowHover, }) => {
    const theme = useTheme();
    const rowRefs = useRef(new Map());
    const sourceNames = useMemo(() => sources.map((source) => source.name), [sources]);
    useEffect(() => {
        var _a;
        if (!scrollToSourceName)
            return;
        if (!sourceNames.includes(scrollToSourceName))
            return;
        (_a = rowRefs.current.get(scrollToSourceName)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: "smooth", block: "center" });
    }, [scrollToSourceName, sourceNames]);
    return (React.createElement(PeekStack, { direction: "column", sx: { minWidth: 900 } },
        React.createElement(TopSourcesHeader, null),
        React.createElement(PeekBox, { width: "100%", bgcolor: theme.palette.grey[50], borderRadius: 1 },
            React.createElement(PeekGrid, { container: true, wrap: "nowrap" },
                React.createElement(PeekGrid, { item: true, xs: 12, direction: "row" }, sources.map((source, index) => {
                    return (React.createElement("div", { key: `${source.name}-${source.rank}`, ref: (node) => {
                            rowRefs.current.set(source.name, node);
                        } },
                        React.createElement(TopSourcesRow, { source: source, hasBorderBottom: sources.length - 1 !== index, isHighlighted: source.name === highlightedSourceName, onRowHover: onRowHover })));
                }))))));
};
export default TopSourcesBody;
